<!-- Individual card start -->
<app-hourglass *ngIf="hourglass"></app-hourglass>
<ng-container *ngIf="admin && !userProfile">
    <mat-card class="cmn-flex flex">
        <mat-card-content>
            <app-autocomplete (autocompleteInput)="onIndividualChanged($event)" (loadRequest)="load($event)"
                              (selection)="selected($event)" [disabled]="hourglass"
                              [hint]="'Search by ID, Name (Last Name, First Name), Email or Phone Number'" [label]="'Search for an Individual'"
                              [objects]="associateNames"
                              [options]="associateNamesFormatted" [page]="pageNum"
                              [searchName]="'Individual'" [debounceTime]="1000"></app-autocomplete>
        </mat-card-content>
    </mat-card>
</ng-container>
<!-- Individual card end -->
<!-- Contacts card start -->
<ng-container *ngIf="isHaveIndividualInfo">
    <mat-card class="cmn-flex flex spaced-top">
        <div class="flex justify-center">
            <mat-hint *ngIf="showResponseRequiredWarning && messageTypesEnabled" class="save-msg">Please ensure a SMS or Teams contact is configured as your response required contact.
            </mat-hint>
        </div>
        <mat-card-header class="form-header">
            <div class="row-flex form-section">
                <div class="name-col">
                    <label>
                        {{currentIndividual.full_name }} - ({{currentIndividual.external_id }})
                        <span *ngIf="currentIndividual.id"
                              class="name-label"> - Alerting ID: {{ currentIndividual.id }}</span>
                        <span *ngIf="!currentIndividual.active"> - (DEACTIVATED - AWAITING DELETION)</span>
                    </label>
                    <mat-card-subtitle *ngIf="currentIndividual.id">
                        Device Name - For use by mainframe: {{currentIndividual.device_name}}
                    </mat-card-subtitle>
                </div>
                <mat-hint *ngIf="!currentIndividual.id" class="save-msg">Not Registered - Press save to complete your
                    registration.
                </mat-hint>
                <span class="row-end">
                    <mat-slide-toggle (change)="reactivateContacts()" *ngIf="currentIndividual.id"
                                      [checked]="currentIndividual.active" [disabled]="currentIndividual.active"
                                      aria-hidden="false" aria-label="Active" color="primary"
                                      matTooltip="Set individual active status"></mat-slide-toggle>
                    <button (click)="deleteIndividual()" *ngIf="userProfile !== true"
                            [disabled]="!currentIndividual.active" aria-label="Delete Icon" color="primary"
                            id="deleteIndividualButton"
                            mat-icon-button matTooltip="Delete User">
                        <mat-icon>delete</mat-icon>
                    </button>
                </span>
            </div>
        </mat-card-header>
        <mat-card-content>
            <form class="row-flex contact-input">
                <mat-form-field class="type">
                    <mat-select (selectionChange)="updateType($event)" [(value)]="contactType"
                                [disabled]="!currentIndividual.active" id="ContactTypeField">
                        <mat-option *ngFor="let type of contactTypes; let i = index"
                                    [value]="type.contact_type">
                            {{type.contact_type}}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Select a Contact Type.</mat-hint>
                </mat-form-field>
                <ng-container *ngIf="contactType === ContactTypeEnum.SMS || contactType === ContactTypeEnum.Voice">
                    <div class="row-flex phone-field">
                        <app-country-code #countryCode [initCC]="indSelected"
                                          [ngClass]="{disabledDiv: !currentIndividual.active}" class="country-code"
                                          id="countrycodeInd"></app-country-code>
                        <mat-form-field class="phone-field">
                            <span matPrefix> +{{ countryCode.getSelectedCountry() }} </span>
                            <input (blur)="toAdd($event)" (keydown)="toAdd($event)" (ngModelChange)="toAdd($event)"
                                   [(ngModel)]="contactField"
                                   [readonly]="!currentIndividual.active" id="contactFieldInd" matInput
                                   name="contactField" pattern="(\d|\(|\)|-|\.)+">
                            <mat-hint *ngIf="contactType === ContactTypeEnum.SMS && (validNumber || contactField.length === 0)">Enter Phone Number (for an SMS enabled device)*</mat-hint>
                            <mat-hint *ngIf="contactType === ContactTypeEnum.Voice && (validNumber || contactField.length === 0)">Enter Phone Number (for Voice calling)*</mat-hint>
                            <mat-hint *ngIf="!validNumber && contactField.length > 0" class="error">Please enter a valid number</mat-hint>
                            <button (click)="add(contactField)" aria-label="Add Icon" color="primary"
                                    id="addContactField"
                                    mat-icon-button matSuffix>
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactType === ContactTypeEnum.Email || contactType === ContactTypeEnum.Teams">
                    <mat-form-field class="contact-field">
                        <input [(ngModel)]="contactField" (blur)="add($event)" (keydown)="add($event)"
                               [readonly]="!currentIndividual.active" id="ContactFieldEmail" matInput
                               name="contactField">
                        <mat-hint *ngIf="validEmail">Enter {{contactOutput}}.*</mat-hint>
                        <mat-hint *ngIf="!validEmail" class="error">Please enter a valid Email</mat-hint>
                        <button (click)="add(contactField)" aria-label="Add Icon" color="primary"
                                id="addContactFieldEmail"
                                mat-button mat-icon-button matSuffix>
                            <mat-icon>add_circle</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngIf="messageTypesEnabled">
                    <button class="ml-2" [ngClass]="{unselected: !responseRequired}" name="responseRequired"
                            (click)="toggleIconButton('responseRequired')" matTooltip="Response Required">
                        <mat-icon>notification_important</mat-icon>
                    </button>
                </ng-container>
                <ng-container>
                    <button *ngIf="messageTypesEnabled" class="ml-2" [ngClass]="{unselected: !informational}" name="informational"
                            (click)="toggleIconButton('informational')" matTooltip="Informational">
                        <mat-icon>info</mat-icon>
                    </button>
                </ng-container>
            </form>

            <div *ngIf="contactType === ContactTypeEnum.Teams" class="flex flex-row items-center">
                <mat-icon class="padded-right-lg">warning</mat-icon>
                <div class="padded">
                    Enter your Teams email to receive alerts as direct messages on Teams. To send messages to a Teams group chat or channel, please create a <a routerLink="/channels">Channel</a> instead.
                </div>
            </div>
            <br>
            <mat-card class="formCard" *ngIf="!messageTypesEnabled">
                <em>Drag contacts for escalation priority.</em>
                <br>
                <br>
                <div class="contacts-chip-list">
                    <mat-chip-list #chipListcontacts (cdkDropListDropped)="drop($event)" aria-label="Contacts"
                                   cdkDropList cdkDropListOrientation="horizontal" class="left w-full">
                        <mat-chip *ngFor="let contact of contactChips; let i = index" [attr.data-index]="i"
                                  [disabled]="isDisabled()" [removable]="removable"
                                  [selectable]="selectable" cdkDrag class="wdAuto row-flex"
                                  id="{{ ordinal(contact.value.address) }}">
                            <mat-radio-button #preferred (change)="changePreferred(contact.value)"
                                              [checked]="contact.value.preferred" [value]="contact.value.preferred"
                                              class="height-align" [disabled]="isDisabled()"
                                              id="contactValueRadio{{i}}"
                                              matTooltip="Click to set as primary contact">&nbsp;
                            </mat-radio-button>
                            <span matTooltip="Priority">{{ contact.value.priority }}</span>
                            <mat-icon *ngIf="isSMS(contact.value)" aria-hidden="false" aria-label="SMS Text"
                                      matTooltip="SMS"> perm_phone_msg
                            </mat-icon>
                            <mat-icon *ngIf="isVoice(contact.value)" aria-hidden="false" aria-label="Voice"
                                      matTooltip="Voice">phone
                            </mat-icon>
                            <mat-icon *ngIf="isEMail(contact.value)" aria-hidden="false" aria-label="EMail"
                                      matTooltip="Email">email
                            </mat-icon>
                            <mat-icon *ngIf="isChat(contact.value)" aria-hidden="false" aria-label="Chat"
                                      matTooltip="Chat - DECOMMISSIONED" color="warn">message
                            </mat-icon>
                            <mat-icon *ngIf="isTeams(contact.value)" aria-hidden="false" aria-label="Teams"
                                      matTooltip="Teams">supervisor_account
                            </mat-icon>
                            {{ contact.displayable || contact.value.address }}
                            <div *ngIf="messageTypesEnabled" class="mt-2">
                                <mat-checkbox [(ngModel)]="contact.value.response_required" (change)="updateMessageType(contact.value)" class="ml-2 " id="ResponseRequired{{i}}">
                                    Response Required
                                </mat-checkbox>
                                <mat-checkbox [(ngModel)]="contact.value.informational" (change)="updateMessageType(contact.value)" class ="ml-2" id="Informational{{i}}">
                                    Informational
                                </mat-checkbox>
                            </div>
                            <mat-slide-toggle [(ngModel)]="contact.value.active"
                                              [disabled]="disabled || isChat(contact.value)"
                                              aria-hidden="false" aria-label="Status" class="templateIconSpacing"
                                              id="ContactValueToggle{{i}}"
                                              matTooltip="Set contact active status"></mat-slide-toggle>
                            <button (click)="remove(contact.value)" *ngIf="[removable]" [disabled]="isDisabled()"
                                    class="chip-button" matChipRemove matTooltip="Click to delete contact">
                                <mat-icon class="chip-icon-button">cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-list>
                    <div class="clear"></div>
                </div>
            </mat-card>
            <!-- chip list -->
            <mat-card *ngIf="messageTypesEnabled" class="formCard flex-col">
                <em>Drag contacts to select which messages they will receive.</em>
                <br>
                <br>
                <div cdkDropListGroup>
                    <div class="grid grid-cols-3 gap-4 divide-x divide-[var(--cmn-text-alt)] rounded-none">
                        <div class="flex flex-col w-full items-center">
                            <label class="text-center w-full ml-2">
                                Informational</label>
                            <mat-chip-list #chipListInformational
                                           [cdkDropListData]="informationalChips"
                                           (cdkDropListDropped)="drop($event)"
                                           accessKey="informational"
                                           cdkDropList
                                           cdkDropListSortingDisabled
                                           cdkDropListOrientation="vertical"
                                           class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                <mat-chip *ngFor="let contact of informationalChips; let i = index" [attr.data-index]="i"
                                          [disabled]="isDisabled()" [selectable]="selectable" cdkDrag [cdkDragData]="contact"
                                          class="w-96 flex-initial" id="{{ ordinal(contact.value.address) }}">
                                    <mat-icon *ngIf="isSMS(contact.value)" aria-hidden="false" aria-label="SMS Text"
                                              matTooltip="SMS" class="mr-2"> perm_phone_msg
                                    </mat-icon>
                                    <mat-icon *ngIf="isVoice(contact.value)" aria-hidden="false" aria-label="Voice"
                                              matTooltip="Voice" class="mr-2">phone
                                    </mat-icon>
                                    <mat-icon *ngIf="isEMail(contact.value)" aria-hidden="false" aria-label="EMail"
                                              matTooltip="Email" class="mr-2">email
                                    </mat-icon>
                                    <mat-icon *ngIf="isChat(contact.value)" aria-hidden="false" aria-label="Chat"
                                              matTooltip="Chat - DECOMMISSIONED" color="warn">message
                                    </mat-icon>
                                    <mat-icon *ngIf="isTeams(contact.value)" aria-hidden="false" aria-label="Teams"
                                              matTooltip="Teams">supervisor_account
                                    </mat-icon>
                                    {{ contact.displayable || contact.value.address }}
                                    <mat-slide-toggle [(ngModel)]="contact.value.active"
                                                      *ngIf="!contact.value.active"
                                                      [disabled]="disabled || isChat(contact.value)"
                                                      aria-hidden="false" aria-label="Status" class="templateIconSpacing right-2 absolute"
                                                      id="ContactValueToggle{{i}}"
                                                      matTooltip="Set contact active status"></mat-slide-toggle>
                                    <button (click)="remove(contact.value)" *ngIf="contact.value.active" [disabled]="isDisabled()"
                                            class="chip-button right-2 absolute" matChipRemove matTooltip="Click to delete contact">
                                        <mat-icon class="chip-icon-button">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-list>
                        </div>

                        <div class="flex flex-col w-full items-center">
                            <label class="text-center w-full ml-2">
                                Response Required</label>
                            <mat-chip-list #chipListResponseRequired
                                           [cdkDropListData]="responseRequiredChips"
                                           (cdkDropListDropped)="drop($event)"
                                           accessKey="responseRequired"
                                           cdkDropList
                                           cdkDropListSortingDisabled
                                           cdkDropListOrientation="vertical"
                                           class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                <mat-chip *ngFor="let contact of responseRequiredChips; let i = index" [attr.data-index]="i"
                                          [disabled]="isDisabled()" [selectable]="selectable" cdkDrag [cdkDragData]="contact"
                                          class="w-96 flex-initial" id="{{ ordinal(contact.value.address) }}">
                                    <mat-icon *ngIf="isSMS(contact.value)" aria-hidden="false" aria-label="SMS Text"
                                              matTooltip="SMS" class="mr-2"> perm_phone_msg
                                    </mat-icon>
                                    <mat-icon *ngIf="isVoice(contact.value)" aria-hidden="false" aria-label="Voice"
                                              matTooltip="Voice" class="mr-2">phone
                                    </mat-icon>
                                    <mat-icon *ngIf="isEMail(contact.value)" aria-hidden="false" aria-label="EMail"
                                              matTooltip="Email" class="mr-2">email
                                    </mat-icon>
                                    <mat-icon *ngIf="isChat(contact.value)" aria-hidden="false" aria-label="Chat"
                                              matTooltip="Chat - DECOMMISSIONED" color="warn">message
                                    </mat-icon>
                                    <mat-icon *ngIf="isTeams(contact.value)" aria-hidden="false" aria-label="Teams"
                                              matTooltip="Teams">supervisor_account
                                    </mat-icon>
                                    {{ contact.displayable || contact.value.address }}
                                    <mat-slide-toggle [(ngModel)]="contact.value.active"
                                                      *ngIf="!contact.value.active"
                                                      [disabled]="disabled || isChat(contact.value)"
                                                      aria-hidden="false" aria-label="Status" class="templateIconSpacing right-2 absolute"
                                                      id="ContactValueToggle{{i}}"
                                                      matTooltip="Set contact active status"></mat-slide-toggle>
                                    <button (click)="remove(contact.value)" *ngIf="contact.value.active" [disabled]="isDisabled()"
                                            class="chip-button right-2 absolute" matChipRemove matTooltip="Click to delete contact">
                                        <mat-icon class="chip-icon-button">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-list>
                        </div>

                        <div class="flex flex-col w-full items-center">
                            <label class="text-center w-full ml-2">
                                Response Required and Informational</label>
                            <mat-chip-list #chipListResponseRequiredAndInfo
                                           [cdkDropListData]="responseRequiredAndInfoChips"
                                           (cdkDropListDropped)="drop($event)"
                                           accessKey="responseRequiredAndInfo"
                                           cdkDropList
                                           cdkDropListSortingDisabled
                                           cdkDropListOrientation="vertical"
                                           class="left size-full min-h-8 max-w-96 mb-1 ml-4">
                                <mat-chip *ngFor="let contact of responseRequiredAndInfoChips; let i = index" [attr.data-index]="i"
                                          [disabled]="isDisabled()" [selectable]="selectable" cdkDrag [cdkDragData]="contact"
                                          class="w-96 flex-initial" id="{{ ordinal(contact.value.address) }}">
                                    <mat-icon *ngIf="isSMS(contact.value)" aria-hidden="false" aria-label="SMS Text"
                                              matTooltip="SMS" class="mr-2"> perm_phone_msg
                                    </mat-icon>
                                    <mat-icon *ngIf="isVoice(contact.value)" aria-hidden="false" aria-label="Voice"
                                              matTooltip="Voice" class="mr-2">phone
                                    </mat-icon>
                                    <mat-icon *ngIf="isEMail(contact.value)" aria-hidden="false" aria-label="EMail"
                                              matTooltip="Email" class="mr-2">email
                                    </mat-icon>
                                    <mat-icon *ngIf="isChat(contact.value)" aria-hidden="false" aria-label="Chat"
                                              matTooltip="Chat - DECOMMISSIONED" color="warn">message
                                    </mat-icon>
                                    <mat-icon *ngIf="isTeams(contact.value)" aria-hidden="false" aria-label="Teams"
                                              matTooltip="Teams">supervisor_account
                                    </mat-icon>
                                    {{ contact.displayable || contact.value.address }}
                                    <mat-slide-toggle [(ngModel)]="contact.value.active"
                                                      *ngIf="!contact.value.active"
                                                      [disabled]="disabled || isChat(contact.value)"
                                                      aria-hidden="false" aria-label="Status" class="templateIconSpacing right-2 absolute"
                                                      id="ContactValueToggle{{i}}"
                                                      matTooltip="Set contact active status"></mat-slide-toggle>
                                    <button (click)="remove(contact.value)" *ngIf="contact.value.active" [disabled]="isDisabled()"
                                            class="chip-button right-2 absolute" matChipRemove matTooltip="Click to delete contact">
                                        <mat-icon class="chip-icon-button">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                    <div class="grid mt-2 border-t border-[var(--cmn-text-alt)]">
                        <div class="flex-col mt-2">
                            <label class="ml-4">
                                Silenced</label>
                            <mat-chip-list #chipListNone
                                           [cdkDropListData]="noneChips"
                                           (cdkDropListDropped)="drop($event)"
                                           accessKey="none"
                                           cdkDropList
                                           cdkDropListSortingDisabled
                                           cdkDropListOrientation="mixed"
                                           class="left size-full min-h-8 ml-2">
                                <mat-chip *ngFor="let contact of noneChips; let i = index" [attr.data-index]="i"
                                          [disabled]="isDisabled()" [selectable]="selectable" cdkDrag [cdkDragData]="contact"
                                          class="w-96 flex-initial" id="{{ ordinal(contact.value.address) }}">
                                    <mat-icon *ngIf="isSMS(contact.value)" aria-hidden="false" aria-label="SMS Text"
                                              matTooltip="SMS" class="mr-2"> perm_phone_msg
                                    </mat-icon>
                                    <mat-icon *ngIf="isVoice(contact.value)" aria-hidden="false" aria-label="Voice"
                                              matTooltip="Voice" class="mr-2">phone
                                    </mat-icon>
                                    <mat-icon *ngIf="isEMail(contact.value)" aria-hidden="false" aria-label="EMail"
                                              matTooltip="Email" class="mr-2">email
                                    </mat-icon>
                                    <mat-icon *ngIf="isChat(contact.value)" aria-hidden="false" aria-label="Chat"
                                              matTooltip="Chat - DECOMMISSIONED" color="warn">message
                                    </mat-icon>
                                    <mat-icon *ngIf="isTeams(contact.value)" aria-hidden="false" aria-label="Teams"
                                              matTooltip="Teams">supervisor_account
                                    </mat-icon>
                                    {{ contact.displayable || contact.value.address }}
                                    <mat-slide-toggle [(ngModel)]="contact.value.active"
                                                      *ngIf="!contact.value.active"
                                                      [disabled]="disabled || isChat(contact.value)"
                                                      aria-hidden="false" aria-label="Status" class="templateIconSpacing right-2 absolute"
                                                      id="ContactValueToggle{{i}}"
                                                      matTooltip="Set contact active status"></mat-slide-toggle>
                                    <button (click)="remove(contact.value)" *ngIf="contact.value.active" [disabled]="isDisabled()"
                                            class="chip-button right-2 absolute" matChipRemove matTooltip="Click to delete contact">
                                        <mat-icon class="chip-icon-button">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
            </mat-card>
            <div *ngIf="currentIndividual.group_ownership !== undefined" id="groupOwnershipDiv">
                <mat-card *ngIf="currentIndividual.group_ownership.length > 0" class="formCard">
                    <mat-card-title>Group Ownership:</mat-card-title>
                    <mat-card-content>
                        <hr class="mb-2">
                        <mat-chip-list [disabled]="!currentIndividual.active">
                            <mat-chip (click)="openGroupPopup(group.id)" (removed)="removeOwnedGroup(group)"
                                      *ngFor="let group of currentIndividual.group_ownership; let i = index"
                                      [disabled]="!currentIndividual.active" class="owner-chip" id="MatchipGroup{{i}}">
                                <span class="mr10">{{ group.name }}</span>
                                <mat-icon class="chip-remove-button" matChipRemove
                                          matTooltip="Click to delete ownership">cancel
                                </mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                    </mat-card-content>
                </mat-card>
            </div>
            <div *ngIf="currentIndividual.group_membership !== undefined" id="groupMembershipDiv">
                <mat-card *ngIf="currentIndividual.group_membership.length > 0" class="formCard">
                    <mat-card-title>Group Membership:</mat-card-title>
                    <mat-card-content>
                        <hr class="mb-2">
                        <mat-chip-list [disabled]="!currentIndividual.active">
                            <mat-chip (click)="openGroupPopup(group.id)" (removed)="removeMembership(group)"
                                      *ngFor="let group of currentIndividual.group_membership; let i = index"
                                      [disabled]="!currentIndividual.active" class="member-chip"
                                      id="matchipmembership{{i}}">
                                <span class="mr10">{{ group.name }}</span>
                                <mat-icon class="chip-remove-button" matChipRemove
                                          matTooltip="Click to delete membership">cancel
                                </mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="mt-5 flex justify-between">
                <div class="flex gap-2">
                    <button (click)="save()"
                            [disabled]="buttonsDisabled || !!this.untestedTeamsContacts.length"
                            class="mat-raised-button mat-primary"
                            id="SaveIndvidual"
                            mat-button> Save
                    </button>
                    <button *ngIf="teamsContactEnabled"
                            (click)="testContact()"
                            [disabled]="buttonsDisabled || !hasTeamsContact"
                            class="mat-raised-button mat-primary"
                            id="testContact"
                            mat-button> Test Contact
                    </button>
                </div>
                <button (click)="cancel()"
                        [disabled]="buttonsDisabled"
                        class="mat-raised-button mat-primary right"
                        id="CancelIndvidual"
                        mat-button> Cancel
                </button>
                <mat-hint *ngIf="!saveValid" class="error ml-2">Must have at least one contact to save.</mat-hint>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
<!-- Contacts card end -->

<ng-container *ngIf="error">
    <div class="adError">
        <div>
            {{nameErrorText}}
            <mat-icon class="icon"></mat-icon>
        </div>
    </div>
</ng-container>
